<template>
    <div id="wrap">
        <!-- skip menu-->
        <ul id="skip_menu" v-if="isHeaderVisible">
            <li><a href="#content_wrap">본문 바로가기</a></li>
            <li><a href="#gnb_nav">주메뉴 바로가기</a></li>
        </ul>

        <!-- header -->
        <Header v-if="isHeaderVisible" :lang="lang" @change-lang="setLang" />

        <!-- content -->
        <router-view v-slot="{ Component }">
            <component :is="Component" :lang="lang" />
        </router-view>
        <!-- //content -->

        <!-- footer -->
        <Footer v-if="isHeaderVisible" :lang="lang" />
    </div>
</template>

<script>
import Header from "@/inc/Header.vue";
import Footer from "@/inc/Footer.vue";

import { ref, computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { closeCommonPopups, openCommonPopups } from "@/utils/popupManager.js";
import { applyCommonMetaTag } from "@/utils/metaTagManager.js";

export default {
    name: "App",
    components: { Header, Footer },
    setup() {
        const route = useRoute();
        const LANG_STORAGE_KEY = "gsretail-lang";

        const isSupportedLang = (value) => value === "ko" || value === "en";
        const getStoredLang = () => {
            try {
                return localStorage.getItem(LANG_STORAGE_KEY);
            } catch {
                return null;
            }
        };
        const setStoredLang = (value) => {
            try {
                localStorage.setItem(LANG_STORAGE_KEY, value);
            } catch {
                // localStorage may be unavailable in some embedded contexts.
            }
        };

        const isGuide = computed(() => route.path.startsWith("/guide"));
        //const hideLayout = computed(() => !!route.meta.hideLayout);
        
        const hideLayout = computed(() => {
            const isMetaHide = !!route.meta.hideLayout;
            const isIframeWindow = window.self !== window.top;

            return isMetaHide || isIframeWindow;
        });

        const isHeaderVisible = computed(() => {
            return !(isGuide.value || hideLayout.value);
        });


        const lang = ref(isSupportedLang(getStoredLang()) ? getStoredLang() : "ko");

        const showRoutePopups = () => {
            if (isGuide.value || hideLayout.value) {
                closeCommonPopups();
                return;
            }
            openCommonPopups(route.fullPath);
        };

        const applyRouteMetaTag = () => {
            applyCommonMetaTag(route.fullPath);
        };

        const setLang = (value) => {
            if (!isSupportedLang(value)) return;

            lang.value = value;
            setStoredLang(value);
        };

        onMounted(() => {
            showRoutePopups();
            applyRouteMetaTag();
        });

        watch(
            () => route.fullPath,
            () => {
                showRoutePopups();
                applyRouteMetaTag();
            }
        );

        return { isGuide, hideLayout, lang, setLang,isHeaderVisible };
    }
};
</script>

<style>
@import "@/assets/css/common.css";
@import "@/assets/css/ui.css";
</style>
